<template>
  <div
    class="referral-indicator d-flex justify-content-center flex-column px-5 mx-auto mt-5 mb-3"
    :class="`step-${step}`"
    style="font-size: 16px; height: 64px; width: 560px"
  >
    <div style="font-size: 16px" class="d-flex justify-content-between">
      <font-awesome-icon
        size="2x"
        :class="step > 0 ? 'text-primary' : 'text-border'"
        :icon="['far', 'envelope-open']"
        v-tooltip.bottom="'Referral viewed'"
        aria-label="Referral viewed"
      />
      <!-- 
      <font-awesome-icon
        size="2x"
        :class="step > 1 ? 'text-primary' : 'text-border'"
        :icon="['far', 'phone-rotary']"
        :pulse="step == 1 && referral.is_incoming"
        v-tooltip.bottom="'Patient contacted'"
      /> -->
      <!-- <font-awesome-icon size="2x" class="text-primary" :icon="['fas', 'phone-office']" /> -->
      <font-awesome-icon
        v-if="referral.is_important || true"
        size="2x"
        :class="step > 2 ? 'text-primary' : 'text-border'"
        :pulse="step == 1 && referral.is_incoming"
        :icon="['far', 'calendar-day']"
        v-tooltip.bottom="'Treatment scheduled'"
      />
      <!-- <font-awesome-icon size="2x" class="text-border" :icon="['fas', 'hand-holding-medical']" /> -->
      <font-awesome-icon
        size="2x"
        :class="step > 3 ? 'text-primary' : 'text-border'"
        :icon="['far', 'notes-medical']"
        :pulse="step == 3 && referral.is_incoming"
        v-tooltip.bottom="'Op report complete'"
      />
      <!-- <font-awesome-icon size="2x" class="text-border" :icon="['fas', 'user-md']" /> phone-volume-->
      <!-- <font-awesome-icon icon="fa-solid fa-hand-holding-medical" /> -->
      <!-- <i class="fa-solid fa-trees fa-fw fa-2x" style="color: var(--primary-color);"></i>
      <i class="fa-solid fa-message-dots fa-fw fa-2x fa-beat-fade" style="color: var(--primary-color); --fa-animation-duration:2s;"></i>
      <i class="fa-light fa-house fa-fw fa-2x" style="color: var(--fa-gravy);"></i>
      <i class="fa-light fa-buildings fa-fw fa-2x" style="color: var(--fa-gravy);"></i> -->
    </div>
    <div class="position-relative d-flex margin-y-3xl margin-x-sm size-xs" style="height: 1em">
      <div
        class="position-absolute z-index-2 dot"
        aria-label="Referral viewed"
        style="left: 0px"
        :class="step > 0 ? 'bg-primary' : 'bg-light'"
        v-tooltip.bottom="'Referral viewed'"
      >
        <small v-if="referral.receiver_viewed_at_time" class="text-hint timestamp">{{
          moment(referral.receiver_viewed_at_time).fromNow()
        }}</small>
      </div>
      <!-- <div class="padding-4xs connect-line" style="">
        <div
          v-if="step > 0"
          :style="`border-top: 0.5em ${step == 1 ? 'dotted' : 'solid'} var(--primary-color); height: 1px;`"
        >
          &nbsp;
        </div>
      </div>
      <div
        class="position-absolute z-index-2 dot"
        :style="referral.is_important || true ? 'left: 31%' : 'left:calc(50% - 1em)'"
        :class="step > 1 ? 'bg-primary' : 'bg-light'"
      >
        <small v-if="referral.patient_called_on" class="text-hint timestamp">{{
          moment(referral.patient_called_on).fromNow()
        }}</small>
      </div> -->
      <div v-if="referral.is_important || true" class="padding-4xs connect-line">
        <div
          v-if="step > 0"
          :style="`border-top: 0.5em ${step == 1 ? 'dotted' : 'solid'} var(--primary-color); height: 1px;`"
        >
          &nbsp;
        </div>
      </div>
      <div
        v-if="referral.is_important || true"
        class="position-absolute z-index-2 dot"
        aria-label="Treatment scheduled"
        v-tooltip.bottom="'Treatment scheduled'"
        style="right: 48%"
        :class="step > 2 ? 'bg-primary' : 'bg-light'"
      >
        <small v-if="referral.scheduled_at_time" class="text-hint timestamp">{{
          moment(referral.scheduled_at_time).fromNow()
        }}</small>
      </div>
      <div class="padding-4xs connect-line">
        <div
          v-if="step > 2"
          :style="`border-top: 0.5em ${step == 3 ? 'dotted' : 'solid'} var(--primary-color); height: 1px;`"
        >
          &nbsp;
        </div>
      </div>
      <div
        class="position-absolute z-index-2 dot"
        style="right: 0px"
        :class="step > 3 ? 'bg-primary' : 'bg-light'"
        aria-label="Op report complete"
        v-tooltip.bottom="'Op report complete'"
      >
        <small v-if="referral.completed_time" class="text-hint timestamp">{{
          moment(referral.completed_time).fromNow()
        }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    referralId: { required: true },
  },

  computed: {
    step() {
      if (this.referral.completed_time) return 4
      if (this.referral.is_marked_scheduled) return 3
      // if (this.referral.patient_called_on) return 2
      if (this.referral.receiver_viewed_at_time) return 1
      return 0
    },
    ...mapGetters('referrals', ['all', 'get']),
    referral() {
      return this.get(this.referralId)
    },
  },
}
</script>

<style scoped>
.size-xs {
  font-size: calc(1em * 0.75);
}
.margin-y-3xl {
  margin-top: calc(1em * 2.5) !important;
  margin-bottom: calc(1em * 2.5) !important;
}
.padding-4xs {
  padding: calc(1em * 4 / 16) !important;
}
.margin-x-sm {
  margin-right: calc(1em * 12 / 16) !important;
  margin-left: calc(1em * 12 / 16) !important;
}
.position-absolute {
  position: absolute;
}
.position-relative {
  position: relative;
}
i[class*='fa-'],
.svg-inline--fa {
  --spacing-inline: var(1em * 2 / 16);
  width: 32px;
}

.connect-line {
  flex-grow: 2;
  background: var(--white);
  border-radius: 1em;
}

.dot {
  top: -0.5em;
  border: 0.5em solid var(--white);
  height: 2em;
  width: 2em;
  border-radius: 1em;
}
.step-0 .dot {
  top: -0.75em;
}

.timestamp {
  position: absolute;
  top: 20px;
  margin-left: -10px;
  white-space: nowrap;
  /* left: 0; */
}
</style>